import { useUserStore } from "../stores/UserStore";
import type { OrderTotalsProps } from "../types/components/OrderTotalsProps";

import "../assets/scss/components/_order-totals.scss";
import { DiscountCode } from "./DiscountCode";

export const OrderTotals = ({ totals, cart }: OrderTotalsProps) => {
	const userDetails = useUserStore.getState().userInfo;

	return (
		<div className="order-totals">
			{cart && Object.keys(cart).length > 0 && (
				<>
					<DiscountCode />

					{totals?.deliveryTotal !== undefined && (
						<div className="row align-items-center justify-content-space-between delivery-total">
							<div className="col-fluid">Delivery</div>
							<div className="col price">
								{totals.deliveryTotal === 0 ? "FREE" : `£${(totals.deliveryTotal ?? 0).toFixed(2)}`}
							</div>
						</div>
					)}

					{totals?.discountTotal > 0 && (
						<div className="row align-items-center justify-content-space-between discount-total">
							<div className="col-fluid">Discount</div>
							<div className="col price">-£{(totals.discountTotal ?? 0).toFixed(2)}</div>
						</div>
					)}

					{totals?.creditTotal > 0 && (
						<div className="row align-items-center justify-content-space-between discount-total">
							<div className="col-fluid">Using Credit</div>
							<div className="col price">-£{(totals.creditTotal ?? 0).toFixed(2)}</div>
						</div>
					)}

					{totals?.grandTotal !== undefined && (
						<div className="row align-items-center justify-content-space-between price-section">
							<div className="col-fluid">Total</div>
							<div className="col price">£{(totals.grandTotal ?? 0).toFixed(2)}</div>
						</div>
					)}

					<br />
				</>
			)}
			{totals?.loyaltyPoints > 0 && userDetails.loyalty_scheme_opted_in == true && (
				<div className="loyalty-points">
					<span>+{(totals.loyaltyPoints ?? 0).toFixed(0)} points with this order</span>
				</div>
			)}
		</div>
	);
};

export default OrderTotals;
